import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Container, PageTitle, NbButton, NbCard, Chip } from "@/components/nb";
import { Link } from "react-router-dom";

const scale = [
  { v: 1, l: "Nope" },
  { v: 2, l: "Meh" },
  { v: 3, l: "Ok" },
  { v: 4, l: "Yes" },
  { v: 5, l: "Love it" },
];

export default function InterestAssessment() {
  const [qs, setQs] = useState([]);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/career/questions").then((r) => setQs(r.data)); }, []);

  const submit = async () => {
    if (Object.keys(answers).length < qs.length) return alert("Answer all questions");
    setLoading(true);
    try { const r = await api.post("/career/assess", { answers }); setResult(r.data); }
    finally { setLoading(false); }
  };

  return (
    <Container>
      <PageTitle eyebrow="INTEREST ASSESSMENT" title="8 gut-checks. That's it." />
      {!result && (
        <div className="space-y-4" data-testid="assess-form">
          {qs.map((q) => (
            <NbCard key={q.idx} className="!p-5" data-testid={`aq-${q.idx}`}>
              <div className="font-heading font-bold text-lg">{q.q}</div>
              <div className="mt-3 flex flex-wrap gap-2">
                {scale.map((s) => {
                  const active = answers[q.idx] === s.v;
                  return (
                    <button key={s.v} onClick={() => setAnswers({ ...answers, [q.idx]: s.v })}
                      data-testid={`aq-${q.idx}-s-${s.v}`}
                      className={`px-4 py-2 rounded-lg nb-border font-mono-sl text-[11px] uppercase ${active ? "bg-sl-secondary nb-shadow" : "bg-white"}`}>
                      {s.v} · {s.l}
                    </button>
                  );
                })}
              </div>
            </NbCard>
          ))}
          <NbButton color="black" onClick={submit} disabled={loading} data-testid="submit-assess">{loading ? "..." : "Reveal my paths"}</NbButton>
        </div>
      )}

      {result && (
        <div data-testid="assess-result">
          <h2 className="font-heading font-black text-3xl tracking-tighter mb-4">Your top 3 paths</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {result.top.map((p, i) => (
              <Link key={p.id} to={`/career/path/${p.id}`} data-testid={`top-${p.id}`}>
                <NbCard color={["primary", "secondary", "tertiary"][i]} className="nb-hover-lg min-h-[220px] flex flex-col justify-between">
                  <Chip color="accent">RANK #{i + 1}</Chip>
                  <div>
                    <h3 className="font-heading font-black text-2xl tracking-tight">{p.title}</h3>
                    <p className="mt-2 text-neutral-800">{p.description}</p>
                  </div>
                </NbCard>
              </Link>
            ))}
          </div>
          <div className="mt-6"><NbButton color="white" onClick={() => setResult(null)} data-testid="retake">Retake</NbButton></div>
        </div>
      )}
    </Container>
  );
}
